import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'lazysizes';
import Clarity from "@microsoft/clarity";
import 'yet-another-react-lightbox/styles.css';
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import {configureSharedAuth} from "@shared/auth/SharedAuth";
import {configureHttpServiceMessages} from "@shared/services/HttpServiceConfig";
import {getRawIdTokenAsString, getRawIdTokenWithGroups} from "./util/AuthUtil";

configureSharedAuth({getRawIdTokenAsString, getRawIdTokenWithGroups});
configureHttpServiceMessages({
    somethingWentWrong: (error) => `Wystąpił błąd: ${error}`,
    serverUnavailable: 'Serwer jest aktualnie wyłączony. Spróbuj ponownie za chwilę.',
});


const projectId = "os3zpotjsv"

Clarity.init(projectId);
// Clarity.consent(false);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_CAPTCHA_V3_SITE_KEY!}
        scriptProps={{async: true, defer: true, appendTo: 'body'}}
    >
        <App/>
    </GoogleReCaptchaProvider>
);

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
        .then(reg => console.log('SW registered:', reg.scope))
        .catch(err => console.error('SW registration failed:', err));
}
